import { Box, styled } from "@mui/material";
import SplitBase from "react-split";

const SplitPane = styled('div')`
  height: "100%";
`;

const Splitter = styled(SplitBase as any)`
  .gutter {
    &.gutter-horizontal {
      flex-basis: 6px;
      margin: 0 5px;
      cursor: ew-resize;
      background: #88888811;
      &:hover {
        justify-content: center;
        display: flex;
        background: #88888844;
        &:before {
          box-sizing: border-box;
          content: "";
          width: 0;
          border: 1px solid #4c9aff;
          display: block;
          height: 100%;
        }
      }
    }
  }
`;

export { SplitPane, Splitter };
